// add +1 to phone number
const phoneNumberWithCountryCode = (phoneNumber) => {
  // remove all non digits, and look for either 10 digit number or 11 digit (starting with 1)
  const match = (`${phoneNumber}`).replace(/\D/g, '').match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `+1${match[2]}${match[3]}${match[4]}`;
  }
  return phoneNumber;
};

export const phoneNumberIsValid = (phoneNumber, onCheckError = () => {}) => {
  if (!phoneNumber) {
    return false;
  }

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const isPhoneNumberValid = phoneRegExp.test(phoneNumber);
  onCheckError(isPhoneNumberValid);
  return isPhoneNumberValid
}

export const cleanPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  return phoneNumber.replace(/[^\d]/g, '');
}

export const formatPhoneNumber = (phoneNumber) => {
  const match = phoneNumber?.replace(/\D/g, '')?.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `${match[2]}-${match[3]}-${match[4]}`;
  }

  return phoneNumber;
}

export default phoneNumberWithCountryCode;
